import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { DARK_THEME, DarkThemeService, LIGHT_THEME } from '@irohalab/deneb-ui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-theme-toggle',
  template: `
    <a
      class="theme-toggle"
      role="button"
      tabindex="0"
      [attr.aria-label]="label()"
      [attr.aria-pressed]="isDarkTheme()"
      [title]="label()"
      (click)="toggleTheme()"
      (keydown)="onKeydown($event)"
    >
      <i class="icon" [class.moon]="!isDarkTheme()" [class.sun]="isDarkTheme()" aria-hidden="true"></i>
    </a>
  `,
  styleUrl: './theme-toggle.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemeToggleComponent {
  protected readonly isDarkTheme = signal(false);
  protected readonly label = computed(() => `Switch to ${this.isDarkTheme() ? 'light' : 'dark'} theme`);

  private readonly darkThemeService = inject(DarkThemeService);

  constructor() {
    this.darkThemeService.themeChange
      .pipe(takeUntilDestroyed())
      .subscribe((theme) => this.isDarkTheme.set(theme === DARK_THEME));
  }

  protected toggleTheme(): void {
    this.darkThemeService.changeTheme(this.isDarkTheme() ? LIGHT_THEME : DARK_THEME);
  }

  protected onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    this.toggleTheme();
  }
}
